
import { $api } from '@/plugins/axios'

export const GetData = async (requestPath: string) => await $api.get(requestPath);
